module.exports = __webpack_public_path__ + "media/images/faq/brand7-cbfc218638132b39ca9c10b5386d101c.png";